"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _pie = require("@nivo/pie");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_pie.ResponsivePie, _extends({
    data: [],
    colors: {
      scheme: 'pastel2'
    },
    margin: {
      top: 50,
      right: 50,
      bottom: 65,
      left: 50
    },
    innerRadius: 0.5,
    padAngle: 0.7,
    cornerRadius: 3,
    borderWidth: 1,
    borderColor: {
      from: 'color',
      modifiers: [['darker', 0.2]]
    },
    arcLabelsSkipAngle: 10,
    arcLinkLabelsSkipAngle: 20,
    animate: true,
    motionStiffness: 90,
    motionDamping: 15,
    legends: [{
      anchor: 'bottom',
      direction: 'row',
      translateY: 56,
      translateX: 25,
      itemWidth: 100,
      itemHeight: 18,
      itemTextColor: '#999',
      symbolSize: 18,
      symbolShape: 'circle',
      effects: [{
        on: 'hover',
        style: {
          itemTextColor: '#000'
        }
      }]
    }]
  }, props));
};

exports["default"] = _default;